import React from 'react';
import { config } from '@uhg-abyss/web/tools/config';
import { LagoonContext } from '@src/AppContext/LagoonContext';
import { IdleUser } from './IdleUser';

export const SessionTimeout = () => {
  const lagoonContext = React.useContext(LagoonContext);

  const uiMessages = lagoonContext.getTable('ui-messaging');

  const onLogout = () => {
    window.location = `${
      uiMessages.getRow('OIDC_API_URL')?.message || config('OIDC_API_URL')
    }/logout`;
  };

  const handleLogout = async () => {
    onLogout();
  };

  const events = {
    onSignout: () => {
      if (config('APP_ENV') !== 'local') {
        handleLogout();
      }
    },
  };

  return (
    <React.Fragment>
      <IdleUser events={events} />
    </React.Fragment>
  );
};
